import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    show_poup_store: false,
    user_data: null,
    words: null,
    ref_sources: null,
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
